export const InsertNewOperation = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
      <path
        fill="#55565C"
        fillRule="evenodd"
        d="M9.375 4.375a1.25 1.25 0 0 1 1.25 1.25h-5a2.5 2.5 0 0 0-2.5 2.5v5a1.25 1.25 0 0 1-1.25-1.25v-6.25a1.25 1.25 0 0 1 1.25-1.25h6.25Zm-5 10a1.25 1.25 0 0 0 1.25 1.25h6.25a1.25 1.25 0 0 0 1.25-1.25v-.625a.625.625 0 1 1 1.25 0v.625a2.5 2.5 0 0 1-2.5 2.5h-6.25a2.5 2.5 0 0 1-2.5-2.5 2.5 2.5 0 0 1-2.5-2.5v-6.25a2.5 2.5 0 0 1 2.5-2.5h6.25a2.5 2.5 0 0 1 2.5 2.5 2.5 2.5 0 0 1 2.5 2.5v.625a.625.625 0 1 1-1.25 0v-.625a1.25 1.25 0 0 0-1.25-1.25h-6.25a1.25 1.25 0 0 0-1.25 1.25v6.25Z"
        clipRule="evenodd"
      />
      <path
        fill="#55565C"
        d="M19.192 10.808a.625.625 0 0 1 0 .884l-2.5 2.5a.625.625 0 1 1-.884-.884l1.433-1.433H8.125a.625.625 0 1 1 0-1.25h9.116l-1.433-1.433a.625.625 0 1 1 .884-.884l2.5 2.5Z"
      />
    </svg>
  )
}
